import { UomCategoryUpdatePage } from '@/features/uom-category/pages/UomCategoryCreatePage copy'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/admin/uom-category/$id/update')({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["uom_category.edit"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: UomCategoryUpdatePage,
})
